import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Grid,
  TableContainer,
  Divider,
  Typography,
} from "@material-ui/core";
import moment from "moment";
import { useStylesAuth } from "../../../../styles/auth/style";

const useStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    padding: 30,
  },
  align: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  alignDatos: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    width: "100%",
    border: "1px solid #ccc",
    borderRadius: ".3em",
    textAlign: "center",
  },
  textObservaciones: {
    width: "100%",
    border: "1px solid #ccc",
    borderRadius: ".5em",
    textAlign: "left",
    padding: "1em",
    wordBreak: "break-word",
  },
}));

export const FormatoImpresionReclamo = ({
  handleClose,
  handlePrintRow,
  componentRef,
  modal,
  reclamo,
  reclamoDesc,
  impresionIngreso
}) => {
  const classes = useStyles();
  const classesAuth = useStylesAuth("light");


  return (
    <>
      <TableContainer className={classes.form}>
        <Grid container spacing={2} ref={componentRef}>
          <Grid item xs={12} className={classes.logo}>
            <Grid container justify="flex-end">
              <Grid item xs={6} className={classesAuth.imageInherit} />
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ marginTop: "1em" }}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid container>
                <Grid item xs={12} className={classes.align}>
                  <Typography style={{ fontSize: "1.5em" }} color="primary">
                    Fecha de Impresión: {moment().format("DD/MM/YYYY")}
                  </Typography>
                </Grid>
                <Grid item xs={12} className={classes.align}>
                  <Typography style={{ fontSize: "1.5em" }} color="primary">
                    Identificacíon N°: {reclamo?.id}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ marginBottom: "2em" }}>
            <Divider />
          </Grid>
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Grid
              container
              spacing={2}
              justify="space-evenly"
              alignItems="flex-end"
            >
              <Grid item xs={4} className={classes.alignDatos}>
                <Typography>Fecha de Recepción:</Typography>
                <Typography variant="overline" className={classes.text}>
                  {moment(reclamo?.fechaCarga).format("DD/MM/YYYY")}
                </Typography>
              </Grid>
              <Grid item xs={4} className={classes.alignDatos}>
                <Typography>Tipo de ingreso:</Typography>
                <Typography variant="overline" className={classes.text}>
                  {reclamo?.descripcionTipoReclamo}
                </Typography>
              </Grid>
              <Grid item xs={4} className={classes.alignDatos}>
                <Typography>Origen:</Typography>
                <Typography variant="overline" className={classes.text}>
                  {reclamo?.descripcionTipoOrigen}
                </Typography>
              </Grid>
              <Grid item xs={4} className={classes.alignDatos}>
                <Typography>Categoría:</Typography>
                <Typography variant="overline" className={classes.text}>
                  {reclamo?.descripcionCategoriaReclamo}
                </Typography>
              </Grid>
              <Grid item xs={4} className={classes.alignDatos}>
                <Typography>Usuario Carga:</Typography>
                <Typography variant="overline" className={classes.text}>
                  {reclamo?.descripcionUsuarioCarga}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ marginBottom: "2em" }}>
            <Divider />
          </Grid>
          <Grid item xs={4} className={classes.alignDatos}>
            <Typography>Beneficiaria/o:</Typography>
            <Typography variant="overline" className={classes.text}>
              {reclamo?.descripcionAfiliado}
            </Typography>
          </Grid>
          <Grid item xs={4} className={classes.alignDatos}>
            <Typography>Numero Beneficiaria/o:</Typography>
            <Typography variant="overline" className={classes.text}>
              {reclamo?.carnet}
            </Typography>
          </Grid>
          <Grid item xs={4} className={classes.alignDatos}>
            <Typography>Seccional:</Typography>
            <Typography variant="overline" className={classes.text}>
              {reclamo?.descripcionSeccional}
            </Typography>
          </Grid>
          <Grid item xs={4} className={classes.alignDatos}>
            <Typography>Correo electrónico:</Typography>
            <Typography variant="overline" className={classes.text}>
              {reclamo?.email}
            </Typography>
          </Grid>
          <Grid item xs={4} className={classes.alignDatos}>
            <Typography>Teléfono:</Typography>
            <Typography variant="overline" className={classes.text}>
              {reclamo?.telefono}
            </Typography>
          </Grid>
          <Grid item xs={4} className={classes.alignDatos}>
            <Typography>Celular:</Typography>
            <Typography variant="overline" className={classes.text}>
              {reclamo?.celular}
            </Typography>
          </Grid>

          <Grid item xs={12} className={classes.alignDatos}>
            <Typography>Derivado:</Typography>
            <Typography variant="overline" className={classes.text}>
              {reclamo?.derivado}
            </Typography>
          </Grid>
          <Grid item xs={12} style={{ marginBottom: "2em" }}>
            <Divider />
          </Grid>
          {/* {impresionIngreso === true ? (
            null
          ) : (
            <Grid item xs={12} className={classes.alignDatos}>
              <Typography>Descripción:</Typography>
              <Typography variant="overline" className={classes.textObservaciones}>
                {reclamo?.descripcion}
              </Typography>
            </Grid>
          )} */}
        </Grid>
        {modal && (
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginTop: "1em",
            }}
          >
            <Button
              style={{ marginRight: 5 }}
              onClick={handleClose}
              variant="contained"
              color="primary"
            >
              Cancelar
            </Button>
            <Button
              onClick={handlePrintRow}
              variant="contained"
              color="primary"
              autoFocus
            >
              Imprimir
            </Button>
          </Grid>
        )}
      </TableContainer>
    </>
  );
};
